import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id", "className", "onUpdate", "render", "placement", "showArrow", "arrowPointAtCenter", "margin", "noDropdownShadow", "autoAdjustOverflow", "size", "adjustMainSize", "data-component-name"],
    _excluded2 = ["dropdownButtonPanel", "dropdown", "children", "onUpdateOpen", "maxDropdownWidth", "dropdownProps"],
    _excluded3 = ["triggerNode", "popoverNode", "open"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-loop-func */

/* eslint-disable no-cond-assign */
import PropTypes from 'prop-types';
import React, { cloneElement } from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
import { setClass } from '@jd/jmtd-tools/es/element';
import DropdownPanel from '../DropdownPanel';
import Popover, { SUB_ALIGN } from '../Popover';
import ConfigConsumerProvider from '../ConfigConsumerProvider';
var LAST_OPEN = Symbol('open'); // 防止循环引用

export default function Dropdown(_ref) {
  var id = _ref.id,
      className = _ref.className,
      onUpdate = _ref.onUpdate,
      _render2 = _ref.render,
      placement = _ref.placement,
      showArrow = _ref.showArrow,
      arrowPointAtCenter = _ref.arrowPointAtCenter,
      margin = _ref.margin,
      noDropdownShadow = _ref.noDropdownShadow,
      autoAdjustOverflow = _ref.autoAdjustOverflow,
      size = _ref.size,
      adjustMainSize = _ref.adjustMainSize,
      trackComponentName = _ref['data-component-name'],
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
    size: size
  }, function (_ref2) {
    var configSize = _ref2.size;
    return /*#__PURE__*/React.createElement(Popover, {
      "data-component-name": trackComponentName,
      margin: margin,
      showArrow: showArrow,
      arrowPointAtCenter: arrowPointAtCenter,
      placement: placement,
      onUpdate: onUpdate,
      autoAdjustOverflow: autoAdjustOverflow,
      adjustMainSize: adjustMainSize,
      openClassName: "jmtd-dropdown-open",
      popoverClassName: classNames('jmtd-dropdown-bottom', className, {
        'jmtd-dropdown-shadow': !noDropdownShadow
      }),
      render: function render(renderContext) {
        var state = renderContext.state;

        var _render = _render2(renderContext, _objectSpread(_objectSpread({}, props), {}, {
          size: configSize
        })),
            dropdownButtonPanel = _render.dropdownButtonPanel,
            dropdown = _render.dropdown,
            children = _render.children,
            _render$onUpdateOpen = _render.onUpdateOpen,
            _onUpdateOpen = _render$onUpdateOpen === void 0 ? function () {} : _render$onUpdateOpen,
            maxDropdownWidth = _render.maxDropdownWidth,
            dropdownProps = _render.dropdownProps,
            otherResult = _objectWithoutProperties(_render, _excluded2);

        return _objectSpread(_objectSpread({}, otherResult), {}, {
          onUpdateOpen: function onUpdateOpen(_ref3) {
            var triggerNode = _ref3.triggerNode,
                popoverNode = _ref3.popoverNode,
                open = _ref3.open,
                arg = _objectWithoutProperties(_ref3, _excluded3);

            // 如果有maxDropdownWidth，计算展开方向
            if (maxDropdownWidth && (placement === 'bottomLeft' || placement === 'topLeft')) {
              if (!state[LAST_OPEN] && open) {
                var _triggerNode$getBound = triggerNode.getBoundingClientRect(),
                    left = _triggerNode$getBound.left,
                    right = _triggerNode$getBound.right;

                var clientWidth = document.documentElement.clientWidth;
                var remind = clientWidth - left;
                var flag = remind < maxDropdownWidth && right > remind;

                if (flag) {
                  popoverNode[SUB_ALIGN] = 1;
                } else {
                  delete popoverNode[SUB_ALIGN];
                }

                setClass(popoverNode, 'jmtd-dropdown-bottom-direction-to-left', flag);
              }

              state[LAST_OPEN] = open;
            }

            _onUpdateOpen(_objectSpread({
              triggerNode: triggerNode,
              popoverNode: popoverNode,
              open: open
            }, arg));
          },
          children: /*#__PURE__*/cloneElement(children, {
            id: id,
            className: classNames(children.props.className, className),
            'data-component-name': trackComponentName,
            'data-event-name': renderContext.open ? 'close' : 'open'
          }),
          popover: /*#__PURE__*/React.createElement(DropdownPanel, _extends({}, dropdownProps, {
            className: classNames({
              'jmtd-dropdown-lists': !dropdownButtonPanel,
              'jmtd-dropdown-with-button-panel': !!dropdownButtonPanel
            })
          }), dropdownButtonPanel ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "jmtd-dropdown-lists"
          }, dropdown), dropdownButtonPanel) : dropdown)
        });
      }
    });
  });
}
Dropdown.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onUpdate: PropTypes.func,
  render: PropTypes.func,
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight']),
  showArrow: PropTypes.bool,
  arrowPointAtCenter: PropTypes.bool,
  margin: PropTypes.number,
  noDropdownShadow: PropTypes.bool,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  autoAdjustOverflow: PropTypes.oneOf(['auto', 'main', 'sub', 'none']),
  adjustMainSize: PropTypes.number,
  'data-component-name': PropTypes.string
};
Dropdown.defaultProps = {
  id: null,
  className: '',
  onUpdate: function onUpdate() {},
  render: null,
  placement: 'bottomLeft',
  showArrow: false,
  arrowPointAtCenter: false,
  margin: undefined,
  noDropdownShadow: false,
  size: null,
  autoAdjustOverflow: 'auto',
  adjustMainSize: null,
  'data-component-name': 'Dropdown'
};